export default "__VITE_ASSET__DBpBxdSj__"